// src/Dashboard/pages/user/Produits/utils/productsUtils.js

export const PRODUCTS_API_URL =
  process.env.REACT_APP_PRODUCTS_API_URL ||
  "https://api.monappliclub.com/api/productsapp/allproductsapp";

export const FALLBACK_PRODUCT_IMAGE = "/img/no-image.jpg";

export const DEFAULT_PRODUCTS_UI = {
  q: "",
  sort: "order",
};

export const DEVELOPER_PROFILE = {
  name: "Laurent VICTORIN",
  role: "Développeur Web & Web Mobile · Président & Enseignant de Judo",
  email: "monappliclub@gmail.com",
  phoneDisplay: "06 80 72 77 07",
  phoneHref: "+33680727707",
  photo:
    "/img/illustration_LV_MAC3.png",
  website: "https://www.monappliclub.com/",
  vkard:
    "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
};

export const DONATION_LINKS = [
  {
    amount: 2,
    label: "2 €",
    title: "Un café pour le développeur",
    url: "https://buy.stripe.com/4gM8wOfn5fDo7zufRU5AQ07",
  },
  {
    amount: 5,
    label: "5 €",
    title: "Un coup de pouce",
    url: "https://buy.stripe.com/cN2aFtaqL5fC1AkcMR",
  },
  {
    amount: 10,
    label: "10 €",
    title: "Un grand soutien",
    url: "https://buy.stripe.com/dRm00ib6PdvgaLG6hk5AQ08",
  },
];

export const collatorFR = new Intl.Collator("fr", {
  sensitivity: "base",
});

export const ensureHttp = (url = "") => {
  const value = String(url || "").trim();
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};

export const toAbsoluteMediaUrl = (url = "") => {
  const value = String(url || "").trim();

  if (!value) return "";

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

  return `${base}${value}`;
};

export const parseDemoLinks = (input) => {
  if (Array.isArray(input)) {
    return input.map((item) => String(item || "").trim()).filter(Boolean);
  }

  return String(input || "")
    .split(/[;\n]/)
    .map((item) => item.trim())
    .filter(Boolean);
};

export const hostLabel = (url, index = 0) => {
  try {
    const parsed = new URL(ensureHttp(url));
    return parsed.hostname.replace(/^www\./, "");
  } catch {
    return `Démo ${index + 1}`;
  }
};

export const getProductName = (product) => {
  return String(product?.nom_app || "").trim() || "Application";
};

export const getProductDescription = (product) => {
  return (
    String(product?.description_app || "").trim() ||
    "Description non renseignée."
  );
};

export const getProductImage = (product) => {
  return toAbsoluteMediaUrl(product?.image_url_app) || FALLBACK_PRODUCT_IMAGE;
};

export const filterAndSortProducts = (products = [], ui = DEFAULT_PRODUCTS_UI) => {
  const query = String(ui.q || "").trim().toLowerCase();

  const filtered = (products || []).filter((product) => {
    const name = String(product?.nom_app || "").toLowerCase();
    const description = String(product?.description_app || "").toLowerCase();

    return !query || name.includes(query) || description.includes(query);
  });

  return filtered.slice().sort((a, b) => {
    if (ui.sort === "alpha") {
      return collatorFR.compare(getProductName(a), getProductName(b));
    }

    return (
      Number(a?.ordre_app ?? 0) - Number(b?.ordre_app ?? 0) ||
      collatorFR.compare(getProductName(a), getProductName(b))
    );
  });
};

export const getProductsShareUrl = (ui) => {
  const params = new URLSearchParams();

  if (ui.q) {
    params.set("q", ui.q);
  }

  if (ui.sort && ui.sort !== DEFAULT_PRODUCTS_UI.sort) {
    params.set("sort", ui.sort);
  }

  const query = params.toString();

  return `${window.location.origin}${window.location.pathname}${
    query ? `?${query}` : ""
  }`;
};

export const truncateText = (value = "", max = 140) => {
  const text = String(value || "").trim();

  if (text.length <= max) return text;

  return `${text.slice(0, max).trim()}…`;
};